export enum DataType {
    string,
    boolean,
    number,
    element
}

export type TableDataTypes = string | number | boolean | JSX.Element;

export class RowObject {
    type: DataType;
    obj: TableDataTypes;
    // tslint:disable-next-line
    f?: any;
    id?: number;
    cssClassName?: string;

    // tslint:disable-next-line
    constructor(type: DataType, obj: TableDataTypes, f?: any, id?: number, cssClassName?: string) {
        this.type = type;
        this.obj = obj;
        this.f = f;
        this.id = id;
        this.cssClassName = cssClassName;
    }
}

export class DescriptionRowObject {
    lable: string;
    description: string;
    constructor(label: string, description: string) {
        this.lable = label;
        this.description = description;
    }
}

export type TbodyType = string | number;

export class Tbody {
    rowIdentifier?: TbodyType;
    rowFunction?: (id: string) => void;
    rowBody: Array<RowObject>;
    descriptionRow?: DescriptionRowObject;

    constructor(
        rowBody: Array<RowObject>,
        rowIdentifier?: TbodyType,
        rowFunction?: (id: string) => void,
        descriptionRow?: DescriptionRowObject
    ) {
        this.rowBody = rowBody;
        this.rowIdentifier = rowIdentifier;
        this.rowFunction = rowFunction;
        this.descriptionRow = descriptionRow;
    }
}



// WEBPACK FOOTER //
// ./src/components/table/tableModels.ts